/**
 * LSA Equipment Guidance - SIMPLIFIED DIRECT SYSTEM
 * Every requirement ID maps directly to guidance - NO MAPPINGS, NO COMPLEXITY
 * Based on Regulations Assistant verified guidance
 */

import { LSA_SIMPLE_GUIDANCE, getLSASimpleGuidance } from './lsa.simple.js';

/**
 * Simple Direct LSA Guidance - NO MAPPINGS
 * @param {string} itemId - Equipment requirement ID
 * @returns {Object|null} Guidance object or null
 */
export function getLSAGuidance(itemId) {
  return getLSASimpleGuidance(itemId);
}

// Export the guidance object for compatibility
export { LSA_SIMPLE_GUIDANCE as LSA_GUIDANCE };